var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79137 3.79563C3.192 3.79563 2.71165 4.27598 2.71165 4.87536V22.2087C2.71165 22.8081 3.192 23.2884 3.79137 23.2884H21.1247C21.7241 23.2884 22.2044 22.8081 22.2044 22.2087V11.3754H23.295V22.2087C23.295 23.4104 22.3264 24.379 21.1247 24.379H3.79137C2.5897 24.379 1.62109 23.4104 1.62109 22.2087V4.87536C1.62109 3.67369 2.5897 2.70508 3.79137 2.70508H14.6247V3.79563H3.79137Z",
    fill: "#002852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5834 2.71263C19.0896 2.71263 17.8786 3.92357 17.8786 5.41735C17.8786 6.91112 19.0896 8.12207 20.5834 8.12207C22.0771 8.12207 23.2881 6.91112 23.2881 5.41735C23.2881 3.92357 22.0771 2.71263 20.5834 2.71263ZM16.7881 5.41735C16.7881 3.32127 18.4873 1.62207 20.5834 1.62207C22.6794 1.62207 24.3786 3.32127 24.3786 5.41735C24.3786 7.51342 22.6794 9.21262 20.5834 9.21262C18.4873 9.21262 16.7881 7.51342 16.7881 5.41735Z",
    fill: "#002852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 10.8376H4.875V9.74707H14.625V10.8376Z",
    fill: "#002852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0417 17.3376H4.875V16.2471H20.0417V17.3376Z",
    fill: "#002852"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.9981ddbd.svg";
export { ForwardRef as ReactComponent };